<template>
  <div
    class="column flex h-full w-full items-center px-3 py-5 border border-primary-400 rounded-lg"
  >
    <div class="flex flex-col gap-6 w-full">
      <div class="text-base leading-none flex justify-between items-center">
        <slot name="header" />
        <slot name="icon" />
      </div>
      <div class="text-lg leading-none font-semibold h-[18px]"><slot /></div>
    </div>
  </div>
</template>
